import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import hi from './locales/hi.json';
import mr from './locales/mr.json';

// Language resources
const resources = {
  en: { translation: en },
  hi: { translation: hi },
  mr: { translation: mr }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    debug: false,

    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tb-language'
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed'
    }
  });

// Keep <html lang> in sync with the active language so screen readers and
// Devanagari font fallbacks apply on first load and on every switch.
const setHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = (lng || 'en').split('-')[0];
  }
};
setHtmlLang(i18n.language);
i18n.on('languageChanged', setHtmlLang);

// Language names for display
export const languageNames: Record<string, { native: string; english: string }> = {
  en: { native: 'English', english: 'English' },
  hi: { native: 'हिन्दी', english: 'Hindi' },
  mr: { native: 'मराठी', english: 'Marathi' }
};

// RTL languages (none currently, but prepared for future)
export const rtlLanguages: string[] = [];

// Check if language is RTL
export const isRTL = (language: string): boolean => {
  return rtlLanguages.includes(language);
};

// Get language direction
export const getLanguageDirection = (language: string): 'rtl' | 'ltr' => {
  return isRTL(language) ? 'rtl' : 'ltr';
};

export default i18n;